import React from "react";
import { Box, Card, Typography, Grid } from "@mui/material";
import { motion } from "framer-motion";
import BabyChangingStationIcon from "@mui/icons-material/BabyChangingStation";
import ChildCareIcon from "@mui/icons-material/ChildCare";
import EscalatorWarningIcon from '@mui/icons-material/EscalatorWarning';
import StrollerIcon from "@mui/icons-material/Stroller";
import ToysIcon from "@mui/icons-material/Toys";
import { useNavigate } from "react-router-dom";

const cardHeight = 150;

const Courses = () => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    navigate("/our-programs");
  };

  return (
    <Box id="courses" sx={{ backgroundColor: "#005ca8", py: 8, px: 4,mt:{xs:-5,md:0} }}>
      <Grid container spacing={4} alignItems="center" justifyContent="center">
        {/* Left Side: Text Content */}
        <Grid item xs={12} md={5}>
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Typography
              sx={{
                fontSize: { xs: "28px", md: "36px" },
                fontWeight: "bold",
                color: "#fff",
                mb: 2,
                fontFamily: "'Comic Sans MS', cursive",
              }}
            >
              OUR PROGRAMS
            </Typography>
            <Typography sx={{ fontSize: "16px", color: "#fff", maxWidth: 450 }}>
              At <strong>PODAR PREP</strong>, we provide optimal stimulation for{" "}
              <strong>energizing the brain cells</strong>, which shape the{" "}
              <strong>behaviour, emotions and development of each child</strong>
              ...
            </Typography>
          </motion.div>
        </Grid>

        {/* Right Side: Cards */}
        <Grid item xs={12} md={7}>
          <Grid container spacing={4} justifyContent="flex-start" mb={2}>
            <Grid item xs={12} sm={4}>
              <Card
                onClick={handleCardClick}
                sx={{
                  backgroundColor: "#e9578c",
                  color: "#fff",
                  textAlign: "center",
                  border: "2px solid white",
                  boxShadow: 5,
                  borderRadius: 4,
                  padding: 3,
                  height: cardHeight,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  transition: "transform 0.3s",
                  "&:hover": {
                    transform: "scale(1.03)",
                  },
                }}
              >
                <Box mb={1}>
                  <StrollerIcon sx={{ fontSize: 40, color: "#fff" }} />
                </Box>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    fontSize: 20,
                    fontFamily: '-moz-initial',
                  }}
                >
                  Play Group
                </Typography>
                <Typography sx={{ fontSize: "14px" }}>
                  (Age 2 - 3 years)
                </Typography>
                <Typography sx={{ fontSize: 14, mt: 1 }}>
                  Class Timing: 9:30am to 1:00pm
                </Typography>
              </Card>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Card
                onClick={handleCardClick}
                sx={{
                  backgroundColor: "#4bb78a",
                  color: "#fff",
                  textAlign: "center",
                  border: "2px solid white",
                  boxShadow: 5,
                  borderRadius: 4,
                  padding: 3,
                  height: cardHeight,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  mt: { xs: 0, md: 8 },
                  transition: "transform 0.3s",
                  "&:hover": {
                    transform: "scale(1.03)",
                  },
                }}
                on
              >
                <Box mb={1}>
                  <ChildCareIcon sx={{ fontSize: 40, color: "#fff" }} />
                </Box>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    fontSize: 20,
                    fontFamily: '-moz-initial',
                  }}
                >
                  Senior Kindergarten
                </Typography>
                <Typography sx={{ fontSize: "14px" }}>
                  (Age 5 - 6 years)
                </Typography>
                <Typography sx={{ fontSize: 14, mt: 1 }}>
                  Class Timing: 9:30am to 1:00pm
                </Typography>
              </Card>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Card
                onClick={handleCardClick}
                sx={{
                  backgroundColor: "#68d0d6",
                  color: "#fff",
                  textAlign: "center",
                  border: "2px solid white",
                  boxShadow: 5,
                  borderRadius: 4,
                  padding: 3,
                  mt: { xs: 0, md: 20 },
                  height: cardHeight,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  transition: "transform 0.3s",
                  "&:hover": {
                    transform: "scale(1.03)",
                  },
                }}
              >
                <Box mb={1}>
                  <EscalatorWarningIcon sx={{ fontSize: 40, color: "#fff" }} />
                </Box>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    fontSize: 20,
                    fontFamily: '-moz-initial',
                  }}
                >
                  DayCare
                </Typography>
                <Typography sx={{ fontSize: "14px" }}>(Age 2+)</Typography>
                <Typography sx={{ fontSize: 14, mt: 1 }}>
                  Class Timing: 9:30am to 1:00pm
                </Typography>
              </Card>
            </Grid>
          </Grid>

          {/* Row 2: 2 cards */}
          <Grid container spacing={4} justifyContent="flex-start">
            <Grid item xs={12} sm={4}>
              <Card
                onClick={handleCardClick}
                sx={{
                  backgroundColor: "#DD6B3D",
                  color: "#fff",
                  textAlign: "center",
                  border: "2px solid white",
                  boxShadow: 5,
                  borderRadius: 4,
                  padding: 3,
                  mt: { xs: 0, md: -20 },
                  height: cardHeight,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  transition: "transform 0.3s",
                  "&:hover": {
                    transform: "scale(1.03)",
                  },
                }}
              >
                <Box mb={1}>
                  <BabyChangingStationIcon
                    sx={{ fontSize: 40, color: "#fff" }}
                  />
                </Box>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    fontSize: 20,
                    fontFamily: '-moz-initial',
                  }}
                >
                  Nursery
                </Typography>
                <Typography sx={{ fontSize: "14px" }}>
                  (Age 3 - 4 years)
                </Typography>
                <Typography sx={{ fontSize: 14, mt: 1 }}>
                  Class Timing: 9:30am to 1:00pm
                </Typography>
              </Card>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Card
                onClick={handleCardClick}
                sx={{
                  backgroundColor: "#9C27B0",
                  color: "#fff",
                  textAlign: "center",
                  border: "2px solid white",
                  boxShadow: 5,
                  borderRadius: 4,
                  padding: 3,
                  mt: { xs: 0, md: -12 },
                  height: cardHeight,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  transition: "transform 0.3s",
                  "&:hover": {
                    transform: "scale(1.03)",
                  },
                }}
              >
                <Box mb={1}>
                  <ToysIcon sx={{ fontSize: 40, color: "#fff" }} />
                </Box>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    fontSize: 20,
                    fontFamily: '-moz-initial',
                  }}
                >
                  Junior Kindergarten
                </Typography>
                <Typography sx={{ fontSize: "14px" }}>
                  (Age 4 - 5 years)
                </Typography>
                <Typography sx={{ fontSize: 14, mt: 1 }}>
                  Class Timing: 9:30am to 1:00pm
                </Typography>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Courses;
